module.exports = __webpack_public_path__ + "static/media/ios-train.368d148d.svg";